/**
 * NiyoThanks — the shared thank-you popup for storefront form submissions.
 *
 *   NiyoThanks.show({
 *     title: 'Thank you, Priya',
 *     message: 'We have received your message.',
 *     reference: 'ENQ-20261010-AB12C',   // optional
 *     note: 'A confirmation is on its way to your inbox.' // optional
 *   });
 *
 * A native <dialog> (Esc, focus trap and focus return come from the browser),
 * created once per page. Styles: snippets/niyo-form-feedback.liquid.
 */
(function () {
  'use strict';
  if (window.NiyoThanks) return;

  var dialog = null;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'niyo-thanks';
    dialog.setAttribute('aria-labelledby', 'niyo-thanks-title');
    dialog.innerHTML =
      '<div class="niyo-thanks__panel">' +
      '<span class="niyo-thanks__mark" aria-hidden="true">' +
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<h2 class="niyo-thanks__title" id="niyo-thanks-title"></h2>' +
      '<p class="niyo-thanks__message"></p>' +
      '<p class="niyo-thanks__ref" hidden>Reference <strong></strong></p>' +
      '<p class="niyo-thanks__note" hidden></p>' +
      '<button type="button" class="niyo-thanks__close">Continue</button>' +
      '</div>';
    dialog.querySelector('.niyo-thanks__close').addEventListener('click', function () {
      dialog.close();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    document.body.appendChild(dialog);
  }

  function show(opts) {
    opts = opts || {};
    if (!dialog) build();
    dialog.querySelector('.niyo-thanks__title').textContent = opts.title || 'Thank you';
    dialog.querySelector('.niyo-thanks__message').textContent = opts.message || '';
    var ref = dialog.querySelector('.niyo-thanks__ref');
    ref.hidden = !opts.reference;
    ref.querySelector('strong').textContent = opts.reference || '';
    var note = dialog.querySelector('.niyo-thanks__note');
    note.hidden = !opts.note;
    note.textContent = opts.note || '';
    if (dialog.open) dialog.close();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('.niyo-thanks__close').focus();
  }

  window.NiyoThanks = { show: show };
})();
